import React, { Fragment } from 'react';

const CoachTeamsTableItem = ({ team, onRemoveCoachFromTeam })=> {
  const { name, category, year, playersCount, videosCount, highlightsCount } = team;
  return (
    <Fragment>
      <span>{name}</span>
      <span>{category}</span>
      <span>{year}</span>
      <span>{playersCount}</span>
      <span>{videosCount}</span>
      <span>{highlightsCount}</span>
      <button className="coach-teams-table__button" onClick={onRemoveCoachFromTeam}>
        <div className="coach-teams-table__button__minus"/>
      </button>
    </Fragment>
  );
};

export default CoachTeamsTableItem;